import React from "react";
import { Modal, Row, Col } from "react-bootstrap";
import { bool, func, object } from "prop-types";

import VideoStateChooser from "../VideoStateChooser";
import VideoReadyToggle from "../VideoReadyToggle";

function VideoBotConfigModal(props) {
  let { show, close, video } = props;
  return (
    <Modal show={show} onHide={close} className="modal--big">
      <Modal.Header closeButton>
        <Modal.Title>Configuração de video</Modal.Title>
      </Modal.Header>
      <Modal.Body className="clearfix">
        <Row>
          <Col md={2}>
            <p>Video Ready:</p>
          </Col>
          <Col md={2}>
            <VideoReadyToggle video={video} />
          </Col>
        </Row>
        <Row>
          <Col md={2}>
            <p>Data State:</p>
          </Col>
          <Col md={6}>
            <VideoStateChooser video={video} />
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

VideoBotConfigModal.propTypes = {
  show: bool,
  close: func,
  video: object
};

export default VideoBotConfigModal;



// WEBPACK FOOTER //
// ./src/components/modals/VideoBotConfigModal.js